<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.clipboard-list-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Dashboard') }}
          </h1>
        </div>
        <div class="flex md:mt-0 md:ml-4">
          <div class="rounded-md shadow-sm md:flex">
            <button class="form-input w-13 bg-white rounded-none rounded-l-md" @click.prevent="searchModel = true">
              <svg-vue class="h-5" icon="font-awesome.search-solid"></svg-vue>
            </button>
            <div class="relative inline-flex rounded-none">
              <select
                @change="letsUpdate"
                aria-label="Sort by"
                class="form-input bg-white rounded-none rounded-none"
                id="payment"
                v-model="filters.payment"
              >
                <option :value="null">{{ $t('By payment') }}</option>
                <option :value="1">{{ $t('paid') }}</option>
                <option :value="0">{{ $t('unpaid') }}</option>
              </select>
            </div>
            <div class="relative inline-flex rounded-none">
              <select
                @change="letsUpdate"
                aria-label="Sort by"
                class="form-input bg-white rounded-none"
                id="status"
                v-model="filters.status"
              >
                <option :value="null">{{ $t('By status') }}</option>
                <template v-for="(status, index) in statusList">
                  <option :key="index" :value="status.id">
                    {{ status.body }}
                  </option>
                </template>
              </select>
            </div>
            <div class="relative inline-flex rounded-none">
              <select
                @change="letsUpdate"
                aria-label="Sort by"
                class="form-input bg-white rounded-none"
                id="status"
                v-model="filters.priority"
              >
                <option :value="null">{{ $t('By priority') }}</option>
                <template v-for="(priority, index) in priorityList">
                  <option :key="index" :value="priority.id">
                    {{ priority.name }}
                  </option>
                </template>
              </select>
            </div>
            <div class="relative inline-flex rounded-none">
              <select
                @change="letsUpdate"
                aria-label="Sort by"
                class="form-input bg-white rounded-none rounded-r-md"
                id="status"
                v-model="filters.technician"
              >
                <option :value="null">{{ $t('By technician') }}</option>
                <template v-for="(technician, index) in technicianList">
                  <option :key="index" :value="technician.id">
                    {{ technician.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 md:px-8">
      <template>
        <div class="py-4">
          <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Amount') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.amount | currency }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">{{ $t('Cost') }}</div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.cost | currency }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">{{ $t('Tax') }}</div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.tax | currency }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Profit') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.profit | currency }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Repair orders') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.orders }}
                </div>
              </div>
            </div>
            <div
              v-for="(filler, index) in states.filtered"
              :key="index"
              @click.prevent="goToStatus(filler.id)"
              class="cursor-pointer bg-white overflow-hidden shadow rounded-lg"
            >
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ filler.title }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ filler.value }}
                </div>
              </div>
            </div>
            <!-- <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Brands') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.brands }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Devices') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.devices }}
                </div>
              </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
              <loading :status="loading"></loading>
              <div class="px-2 py-2 sm:p-3">
                <div class="text-sm font-medium truncate">
                  {{ $t('Defects') }}
                </div>
                <div class="mt-1 text-xl font-semibold text-gray-900">
                  {{ states.defects }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="py-4">
          <div class="grid grid-cols-1 gap-6">
            <div class="flex flex-col bg-white rounded-lg shadow">
              <div class="p-4">
                <div class="font-semibold">
                  {{ $t('Annual repair orders') }}
                </div>
              </div>
              <div class="p-4">
                <loading :status="loading"></loading>
                <line-chart :chart-data="chartData" :height="350" ref="chart"></line-chart>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- search model start -->
    <search-model :show="searchModel" @close="closeSearch">
      <div class="flex-auto max-h-screen h-100 overflow-hidden flex flex-col">
        <loading :status="isSearching" />
        <div class="p-2 border-b border-gray-300">
          <div class="flex border-blue-400 border-2 rounded overflow-hidden">
            <input
              @keyup.enter="search"
              v-model="searchValue"
              ref="searchField"
              type="text"
              class="p-2 outline-none flex-auto text-gray-700 bg-blue-100"
            />
            <button @click="search" class="px-2 bg-blue-400 text-white">{{ $t('Search') }}</button>
          </div>
        </div>
        <div class="overflow-y-auto  flex-auto relative">
          <ul>
            <li
              v-for="item of searchedProducts"
              :key="item.id"
              @click="addToCart(item)"
              class="hover:bg-blue-50 rounded-md w-full cursor-pointer p-2 flex justify-between border-b"
            >
              <div class="flex-shrink-0 w-15 h-15 border border-gray-200 rounded-md overflow-hidden">
                <img :src="item.image" :alt="item.name" class="w-full h-full object-center object-cover" />
              </div>
              <div class="ml-4 flex-1 flex flex-col">
                <div class="text-xs flex justify-between font-medium text-gray-900">
                  <div>
                    <h3>{{ item.name }}</h3>
                    <h3 class="text-gray-500 mt-2">
                      {{ $t('Brand') }}: {{ item.brand_name }}<br/>
                    {{ $t('Attached repairable defects') }}: {{ item.defects.length }}</h3>
                  <ul class="w-full" v-if="item.defects.length">
                    <li class="w-full border space-x-5 p-1 my-1 bg-gray-50 flex justify-between" v-for="defect in item.defects">
                      {{defect.title}}

                      {{defect.price|currency}}
                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </li>
             <li v-if="searchedProducts.length === 0" class="text-gray-700 text-center p-2">
              {{ $t('There is nothing to display. Have you started the search ?') }}
            </li>
          </ul>
        </div>
      </div>
    </search-model>
    <!-- search model -->
  </main>
</template>
<script>
import LineChart from '@/components/elements/line-chart';
import model from '@/components/elements/model';

export default {
  name: 'dashboard',
  metaInfo() {
    return {
      title: this.$i18n.t('Admin dashboard'),
    };
  },
  components: { LineChart,'search-model': model,  },
  data() {
    return {
      searchModel: false,
      isSearching: false,
      searchValue: null,
      searchedProducts: [],

      loading: false,
      statusList: [],
      priorityList: [],
      technicianList: [],
      filters: {
        status: null,
        priority: null,
        technician: null,
        payment: null,
      },
      states: {
        amount: 0,
        brands: 0,
        cost: 0,
        filtered: [],
        defects: 0,
        devices: 0,
        orders: 0,
        profit: 0,
        tax: 0,
      },
      chartData: {
        labels: [
          this.$t('Jan'),
          this.$t('Feb'),
          this.$t('Mar'),
          this.$t('Apr'),
          this.$t('May'),
          this.$t('Jun'),
          this.$t('Jul'),
          this.$t('Aug'),
          this.$t('Sept'),
          this.$t('Oct'),
          this.$t('Nov'),
          this.$t('Dec'),
        ],
        datasets: [
          {
            label: this.$i18n.t('Repair Orders'),
            backgroundColor: '#4299e1',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
    };
  },
  mounted() {
    this.getFilters();
    this.getStates();
    this.getData();
  },
  computed: {
    anyFilter() {
      return this.filters.status !== null || this.filters.payment !== null || this.filters.priority !== null;
    },
    datasets() {
      return this.chartData.datasets[0].data;
    },
  },
  watch: {
    datasets() {
      this.$refs.chart.update();
    },
  },
  methods: {
   search() {
      this.isSearching = true;
      if (this.searchValue) {
        axios
          .post(route('search-repair-price'), { search: this.searchValue })
          .then((response) => {
            this.isSearching = false;
            this.searchedProducts = response.data;
          })
          .catch((error) => {
            this.isSearching = false;
          });
      } else {
        this.isSearching = false;
        this.$notify({
          title: this.$i18n.t('Warning').toString(),
          text: this.$i18n.t('Please enter something to process search').toString(),
          type: 'warning',
        });
      }
    },
    closeSearch() {
      this.searchModel = false;
      this.searchValue = null;
      this.searchedProducts = [];
    },
    goToStatus(id) {
      this.$router.push(`/admin/repair-statuses/${id}/edit`);
    },
    letsUpdate() {
      this.getStates();
      this.getData();
    },
    getFilters() {
      axios.get(route('repair-orders.filters')).then((response) => {
        this.statusList = response.data.statuses;
        this.priorityList = response.data.priorities;
        this.technicianList = response.data.technicians;
      });
    },
    getStates() {
      this.loading = true;
      axios
        .get(route('dashboard.states'), {
          params: this.filters,
        })
        .then((response) => {
          this.loading = false;
          this.states = response.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getData() {
      this.loading = true;
      axios
        .get(route('dashboard.annual.graph'), {
          params: this.filters,
        })
        .then((response) => {
          this.chartData.datasets[0].data = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
